module.exports = __webpack_public_path__ + "static/img/home-bg.7d0aed3b.png";